var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackagesBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 541.278,
    height: 278.896,
    viewBox: "0 0 541.278 278.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304",
    transform: "translate(-30.721 -3840)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301",
    transform: "translate(30.721 3840)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M128.288,173.92,18.3,221.979,15,52.283,128.288,24Z",
    transform: "translate(176.533 51.422)",
    fill: "#4c427d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M199.877,35.179l3.3,169.7L52.339,157.737,50,36.75l140.175-4.767Z",
    transform: "translate(-8.345 68.525)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M167.594,4l3.146,79.8L62,48Z",
    transform: "translate(-13.613 8.571)",
    fill: "#4c427d",
    opacity: 0.888
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M165.841,48,52.553,95.133,18.146,83.8,15,4Z",
    transform: "translate(138.981 8.571)",
    fill: "#4c427d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M154,65.138,40.867,115.418,3,65.138,116.288,18Z",
    transform: "translate(188.534 38.566)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M169.843,0,216.98,12.573,111.386,56.565,63,43.995Z",
    transform: "translate(-63 0)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M239.444,65.138l-40.7,53.423L51.05,62,96.3,18Z",
    transform: "translate(-47.911 38.566)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M197.978,45l-47.138,9.428L0,10.428,59.708,1Z",
    transform: "translate(153.981 2.143)",
    fill: "#79719e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(376.91 3919.483)",
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M82.266,144.7,0,177.805V51.257L82.266,16Z",
    transform: "translate(112.822 21.607)",
    fill: "#4c427d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M147.822,52.607V179.156L35,144.275,37.351,15Z",
    transform: "translate(-35 20.256)",
    fill: "#201547"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M82.266,0,192.737,37.605,110.471,72.865,0,35.255Z",
    transform: "translate(2.351 0)",
    fill: "#79719e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M34.847,5.143l111.68,37.09-20.809,8.918-114.232-36Z",
    transform: "translate(21.564 6.945)",
    fill: "#9a92bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M12.283,54.01l-.8-24.17,20.809-8.918v27.97L12.283,56.361Z",
    transform: "translate(135.796 28.255)",
    fill: "#201547"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackagesBg);
export default __webpack_public_path__ + "static/media/packages-bg.c76c4b52afbdac6296ffaf9aa3a1ec7d.svg";
export { ForwardRef as ReactComponent };